import StorePage from './store-page';

export default StorePage;
